import React, { FC, useState, useEffect, useContext } from 'react';

import { Course, Matches, TeamGameMatch } from '../../../../../database.schema';
import { ApplyTeamGameResults } from './apply-team-game-results';
import { useParams } from 'react-router-dom';
import { TierMatchData, useFetchTierPointsMatchEntryData } from '../../../../api/hooks/use-fetch-match-entry-data';

const initialMatches: Matches = {
  courseId: -1,
  format: 'Pairs',
  matches: [],
  startingHole: 1,
};

export const EdtTeamGameMatch: FC = (): JSX.Element => {
  let params = useParams();
  const tournamentIndex = Number(params.tournamentIndex);
  const matchIndex = Number(params.matchIndex);
  const { data, isLoading, error } = useFetchTierPointsMatchEntryData(tournamentIndex, matchIndex);
  const [recordedMatch, setRecordedMatch] = useState<TeamGameMatch>();
  const [coursesStore, setCoursesStore] = useState<Array<Course>>([]);

  useEffect(() => {
    if (data) {
      const { match, courses } = data as TierMatchData;
      if (match) {
        setRecordedMatch({ ...match });
      }
      if (courses) {
        setCoursesStore(courses);
      }
    }
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error...</div>;
  }
  if (recordedMatch) {
    return <ApplyTeamGameResults match={recordedMatch} matchIndex={matchIndex} selectedTournamentIndex={tournamentIndex} courses={coursesStore} />;
  }
  return <div>We seem to have a problem</div>;
};
